export const agGridClientesDefs = [
    {
        headerName: 'Número',
        field: 'cl_num',
        width: 150,
        maxWidth: 150
    },
    {
        headerName: 'Nombre',
        field: 'cl_aseg',
        width: 400
    },
    {
        headerName: 'RFC',
        field: 'cl_rfc'
    },
    {
        headerName: 'Alta',
        field: 'cl_altacia'
    },
    {
        headerName: 'Domicilio',
        field: 'cl_dom'
    },
    {
        headerName: 'CP',
        field: 'cl_cp'
    },

    {
        headerName: 'Población',
        field: 'cl_pob'
    }
];

export const agGridClientesDefsNoEdit = [
    {
        headerName: 'Grupo',
        field: 'cl_gpo',
        checkboxSelection: false,
        width: 150,
        maxWidth: 150
    },
    {
        headerName: 'Número',
        field: 'cl_num',
        width: 150,
        maxWidth: 150
    },
    {
        headerName: 'Nombre',
        field: 'cl_aseg',
        width: 400
    },
    {
        headerName: 'Clave',
        field: 'cl_age',
        width: 150,
        maxWidth: 150
    },
    {
        headerName: 'Alta',
        field: 'cl_falta'
    },
    {
        headerName: 'Nacimiento',
        field: 'cl_fela'
    },
    {
        headerName: 'Tel Casa',
        field: 'cl_telc'
    },
    {
        headerName: 'Tel Ofic2',
        field: 'cl_telo2'
    },
    {
        headerName: 'Celu',
        field: 'cl_celu'
    },
    {
        headerName: 'Email',
        field: 'cl_email'
    },
    {
        headerName: 'Email2',
        field: 'cl_email2'
    }
];

export const agGridPolizasBusquedaDefs = [
    {
        headerName: 'Compañía',
        field: 'sl_cia'
    },
    {
        headerName: 'Póliza',
        field: 'sl_pol',
        width: 400
    },
    {
        headerName: 'Vigencia',
        field: 'Sl_vig2'
    },
    {
        headerName: 'Asegurado',
        field: 'sl_aseg',
        width: 500
    }
];

